"use client"

import { useEffect, useState } from "react"
import { useAccount } from "../context/AccountContext"
import { getAuth } from "firebase/auth"
import { getDatabase, ref, get } from "firebase/database"

export const useGetCurrentUserId = () => {
  const { currentAccount, accountSwitchTrigger } = useAccount()
  const [userId, setUserId] = useState(null)
  const [isPartner, setIsPartner] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const determineUserId = async () => {
      setLoading(true)
      const auth = getAuth()
      const user = auth.currentUser

      if (!user) {
        setUserId(null)
        setIsPartner(false)
        setLoading(false)
        return
      }

      const database = getDatabase()

      // 1️⃣ If currentAccount exists in AccountContext, use it directly
 if (currentAccount?.uid) {
  setUserId(currentAccount.uid)
  setIsPartner(currentAccount.type === "partner")
  setLoading(false)
  return
}

      // 2️⃣ If user is listed as a partner under any main account in DB
      try {
       const userSnap = await get(ref(database, `profileDashboard/${user.uid}`))

if (userSnap.exists()) {
  const userData = userSnap.val()

  // 🔥 If it's a partner
  if (userData.type === "partner" && userData.ownerId) {
    setUserId(userData.ownerId)
    setIsPartner(true)
    setLoading(false)
    return
  }

  // 🔥 If it's a firm (optional depending on your structure)
  if (userData.type === "firm") {
    setUserId(user.uid)
    setIsPartner(false)
    setLoading(false)
    return
  }
}
      } catch (error) {
        console.error("[v1] Error checking partner/firms status:", error)
      }

      // 3️⃣ Fallback: Use auth user's own ID
      setUserId(user.uid)
      setIsPartner(false)
      setLoading(false)
    }

    determineUserId()
  }, [currentAccount, accountSwitchTrigger])

  return { userId, isPartner, loading }
}
